const statuses = {
    actual:["need-check", "approved", "invite-sent", "invite-accepted"],
    final: ["banned", "child-in-kindergarten"],
    archive:["removed"],
    canAdd: ["need-check", "approved"]
}

export default statuses;